var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import authentication from "@irati/auth";
import API from "@irati/utils/services/API";
import client from "@irati/utils/services/apollo";
import graph from "@irati/utils/services/graph";
import PBService from "@irati/utils/services";
import { E2E } from "@irati/utils/constants/environment";
import env from "@irati/utils/env";
import { isGlobalAdmin } from "@irati/identity/helpers/user/role";
import loginErrorCodes from "../errorCodes/Login";
import loginErrorHandler from "./errors/legacy/loginErrorHandler";
import { toString as loginQuery } from "./queries/login";
import { toString as ssoLoginQuery } from "./queries/ssoLogin";
import activeSessionsQuery from "./queries/loginActiveSessions";
import loginRemoveActiveSessionMutation from "./mutations/loginRemoveActiveSession";
import loginLogoutMutation from "./mutations/loginLogout";
import AuthStream from "../streams/auth";
import tokens from "./tokens";
import mfa from "./mfa";
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Login.prototype.watchActive = function (userId, options) {
        if (userId === void 0) { userId = authentication.user().uuid; }
        if (options === void 0) { options = {}; }
        var variables = { userId: userId };
        return client.watchQuery(__assign(__assign({}, options), { query: activeSessionsQuery, variables: variables }));
    };
    Login.prototype.removeActiveSession = function (sessionId, userId) {
        if (userId === void 0) { userId = authentication.user().uuid; }
        var variables = { userId: userId, sessionId: sessionId };
        return client.mutate({ mutation: loginRemoveActiveSessionMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            var cachedData = client.readQuery({ query: activeSessionsQuery, variables: { userId: userId } });
            if (cachedData === null || cachedData === void 0 ? void 0 : cachedData.loginActiveSessions) {
                client.writeQuery({
                    query: activeSessionsQuery,
                    variables: { userId: userId },
                    data: {
                        loginActiveSessions: cachedData.loginActiveSessions.filter(function (t) { return t.uuid !== sessionId; })
                    }
                });
            }
            return data.loginRemoveActiveSession;
        });
    };
    Login.prototype.logout = function () {
        if (API.hasTokens()) {
            client.mutate({ mutation: loginLogoutMutation });
        }
        return AuthStream.stop().then(function () { return true; });
    };
    Login.prototype.login = function (tenant, email, password) {
        var options = {
            useErrorHandler: false,
            unAuth: true
        };
        API.sentryIgnoreError(options, [loginErrorCodes.LoginChallengeNewPasswordRequired, loginErrorCodes.UserNotFound]);
        var variables = {
            email: email,
            password: password,
            tenantId: tenant.uuid
        };
        return graph({ query: loginQuery, variables: variables }, options).then(function (data) {
            var _a = data.login, accessToken = _a.accessToken, rest = __rest(_a, ["accessToken"]);
            tokens.set({ accessToken: accessToken });
            if (env.ENVIRONMENT_NAME === E2E) {
                return AuthStream.start(rest);
            }
            return forceAdminMFASetup(rest.business, rest.user).then(function () {
                return AuthStream.start(rest);
            });
        });
    };
    Login.prototype.ssoLogin = function (tenant, user, accessToken) {
        var options = {
            useErrorHandler: false
        };
        var variables = {
            userId: user.uuid,
            accessToken: accessToken,
            tenantId: tenant.uuid
        };
        tokens.set({ accessToken: accessToken });
        return graph({ query: ssoLoginQuery, variables: variables }, options).then(function (data) {
            return forceAdminMFASetup(data.login.business, data.login.user).then(function () {
                return AuthStream.start(data.login);
            });
        });
    };
    return Login;
}(PBService));
export default new Login({ errorHandlers: [loginErrorHandler] });
function forceAdminMFASetup(business, user) {
    return __awaiter(this, void 0, void 0, function () {
        var mfaSetup, e_1, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isGlobalAdmin(business, user)) return [3 /*break*/, 5];
                    return [4 /*yield*/, mfa.getUser(user.uuid)];
                case 1:
                    mfaSetup = _a.sent();
                    if (!!mfaSetup) return [3 /*break*/, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, mfa.hasFlag()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    err = new Error();
                    err.message = "platform.mfa.mfaError.adminsRequired";
                    throw err;
                case 5: return [2 /*return*/];
            }
        });
    });
}
